<template>
  <router-view />
</template>

<style lang="scss">
#app {
  font-family: "MarkOffcForMC", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

@font-face {
  font-family: "MarkOffcForMC";
  font-display: swap;
  src: url("../src/assets/fonts/MarkWebW01Regular.eot");
  src: url("../src/assets/fonts/MarkWebW01Regular.eot?#iefix") format("eot"),
    url("../src/assets/fonts/MarkWebW01Regular.woff2") format("woff2"),
    url("../src/assets/fonts/MarkWebW01Regular.woff") format("woff"),
    url("../src/assets/fonts/MarkWebW01Regular.ttf") format("truetype");
}

@font-face {
  font-family: "MarkOffcForMC-Bold";
  font-display: swap;
  src: url("../src/assets/fonts/MarkWebPro-BoldW01Regular.eot");
  src: url("../src/assets/fonts/MarkWebPro-BoldW01Regular.eot?#iefix")
      format("eot"),
    url("../src/assets/fonts/MarkWebPro-BoldW01Regular.woff2") format("woff2"),
    url("../src/assets/fonts/MarkWebPro-BoldW01Regular.woff") format("woff"),
    url("../src/assets/fonts/MarkWebPro-BoldW01Regular.ttf") format("truetype");
}

@font-face {
  font-family: "MarkOffcForMC-Medium";
  font-display: swap;
  src: url("../src/assets/fonts/MarkWebPro-MediumW01Regular.eot");
  src: url("../src/assets/fonts/MarkWebPro-MediumW01Regular.eot?#iefix")
      format("eot"),
    url("../src/assets/fonts/MarkWebPro-MediumW01Regular.woff2") format("woff2"),
    url("../src/assets/fonts/MarkWebPro-MediumW01Regular.woff") format("woff"),
    url("../src/assets/fonts/MarkWebPro-MediumW01Regular.ttf")
      format("truetype");
}

@font-face {
  font-family: "MarkOffcForMC-Light";
  font-display: swap;
  src: url("../src/assets/fonts/MarkWebPro-LightW01Regular.eot");
  src: url("../src/assets/fonts/MarkWebPro-LightW01Regular.eot?#iefix")
      format("eot"),
    url("../src/assets/fonts/MarkWebPro-LightW01Regular.woff2") format("woff2"),
    url("../src/assets/fonts/MarkWebPro-LightW01Regular.woff") format("woff"),
    url("../src/assets/fonts/MarkWebPro-LightW01Regular.ttf") format("truetype");
}

body,
html {
  margin: 0;
  padding: 0;
  color: #141413;
  font-size: 14px;
  background-color: #141413;
}

.container {
  width: 100%;
  margin: 0;
}

.row {
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.row:after {
  display: grid;
  clear: both;
  content: " ";
}

.row [class*="col-"] {
  min-height: 1px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.col-12 {
  width: 100%;
}

.col-6 {
  width: 50%;
}

.grid-container,
.container {
  margin: 0 auto;
  width: 100%;
}
</style>
